import React from 'react';
import { styles } from './PopoutDrawer.css';
import { Slideout } from '@jbhi-fi/components/src/Slideout/Slideout';
import { useBreakpoint } from '@jbhi-fi/lanyard-ui/utils/useBreakpoint';

export type PopoutDrawerProps = {
  title: string;
  anchor: 'left' | 'right';
  isOpen: boolean;
  onClose: (isOpen: boolean) => void;
  children?: any;
};

const PopoutDrawer = ({ title, anchor, isOpen, onClose, children }: PopoutDrawerProps) => {
  const isDesktop = useBreakpoint('lg', 'up');
  return (
    <Slideout
      isOpen={isOpen}
      onClose={() => onClose(false)}
      size={isDesktop ? '25rem' : '100%'}
      backgroundColor="white"
      anchor={anchor}
    >
      <div className={styles.header} data-testid="pop-out-drawer-title">
        {title}
      </div>
      <div data-testid="pop-out-drawer-content">{children}</div>
    </Slideout>
  );
};

export default PopoutDrawer;
